// tslint:disable-next-line strict-type-predicates no-typeof-undefined
export default Boolean(typeof process !== 'undefined' && process.versions && process.versions.node);
